// src/crypto/params.ts
// 集中存放所有加密参数；SEC 在 audit 时只看这一个文件。
// 任何字段任何参数任何 AAD 结构的改动都必须 bump CRYPTO_VERSION。
export const CRYPTO_VERSION = 1; // u8
// Passphrase → KEK（客户端 Argon2id）
export const ARGON2 = {
    memoryKiB: 47104, // 46 MiB（OWASP 2024）
    iterations: 2,
    parallelism: 1,
    outputLen: 32,
};
// 服务端登录密码 → password_hash（PRD v1.1 决策 ① 覆盖 SEC v0 的 600k）
// 理由：PRD v1.1 把 PBKDF2 收口到 100k 以卡进 Workers 免费层 10ms CPU。
// SEC v1 同步更新中。
export const PBKDF2 = {
    iterations: 100_000,
    outputLen: 32, // bytes
    saltLen: 16, // bytes
    hash: "SHA-256",
};
// AEAD: XChaCha20-Poly1305
export const AEAD = {
    nonceLen: 24,
    tagLen: 16,
    keyLen: 32,
};
// 客户端登录密码下限（注册时 enforce）
export const PASSPHRASE_MIN_LEN = 12;
export const PASSPHRASE_MIN_CLASSES = 3; // 小写/大写/数字/符号 中至少 3 类
// 自动锁
export const AUTO_LOCK_IDLE_MS = 5 * 60 * 1000;
// 错误密码
export const LOCAL_FAIL_BACKOFF_MS = 60_000;
export const LOCAL_FAIL_BACKOFF_AFTER = 5;
export const LOCAL_FAIL_WIPE_AFTER = 10;
// 服务端速率（CF Rate Limiting 规则；OPS 同步配置）
export const RATE_LIMIT = {
    register_per_ip_per_hour: 5,
    login_per_ip_per_minute: 10,
    reset_per_email_per_hour: 3,
};
// 密码重置 token
export const RESET_TOKEN_BYTES = 32;
export const RESET_TOKEN_TTL_MS = 15 * 60 * 1000;
// 服务端"恒定耗时"上下界（防账号枚举）
export const RESET_CONSTANT_TIME_MIN_MS = 4_000;
export const RESET_CONSTANT_TIME_MAX_MS = 6_000;
// 媒体 pre-sign
export const MEDIA_PRESIGN_TTL_S = 300;
// HKDF info domain 分隔
export const INFO = {
    entry: "entry|v1|",
    media: "media|v1|",
    thumb: "thumb|v1|",
    index: "index|v1|",
    backup: "backup|v1|",
    // PRD v1.1 决策 ②：草稿走加密 IDB
    draft: "draft|v1|",
};
